import React, { useEffect, useMemo, useState } from 'react';
// import { connect } from 'react-redux';
import SelectInsuranceSC, { SelectInsuranceErrorSC } from './select-insurance.styled';
import { Formik } from 'formik';
import SelectInsuranceFormSchema from './select-insurance-rules';
import { BodyText, HeadingFour, SmallText } from '../../typography';
import { FormattedMessage, injectIntl } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import Select, { components } from 'react-select';
import chevronImg from '../../../assets/img/svg/chevron-down.svg';
import numeral from 'numeral';
import Checkbox from '../../ui/checkbox';

const SelectInsurance = ({ onSubmitForm, onBoardingStepData, intl, euroFormat, disabled }) => {
  const [insuranceVariant, setInsuranceVariant] = useState();
  const [insuranceSelectData, setInsuranceSelectData] = useState([]);

  const formInitialValues = useMemo(() => {
    if (insuranceVariant) {
      return {
        variant: insuranceVariant,
        questions: [
          ...onBoardingStepData?.insurance_variants
            ?.find((item) => item.id === insuranceVariant)
            ?.questions.map((item, index) => ({
              id: item.id,
              answer: item.type === 'boolean' ? (index === 0 ? true : false) : '',
            })),
        ],
      };
    } else {
      return {
        variant: null,
        questions: [],
      };
    }
  }, [insuranceVariant, onBoardingStepData]);

  useEffect(() => {
    setInsuranceVariant(onBoardingStepData?.insurance_variants[0]?.id);
    setInsuranceSelectData([
      ...onBoardingStepData.insurance_variants?.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      {
        value: null,
        label: (
          <FormattedMessage
            id="onboarding_select_no_insurance_label"
            defaultMessage={dlt['onboarding_select_no_insurance_label']}
          />
        ),
      },
    ]);
  }, [onBoardingStepData]);

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={chevronImg} alt="" />
      </components.DropdownIndicator>
    );
  };

  const calculateInsuranceCost = (id) => {
    const insuranceItem = onBoardingStepData.insurance_variants.find((item) => item.id === id);
    const type = insuranceItem?.actual_validity?.value_type;
    const insuranceValue = insuranceItem?.actual_validity?.value;
    if (id && type && insuranceValue) {
      if (type === 'percentage') {
        return `${numeral((insuranceValue / 100) * onBoardingStepData.loan_amount).format(
          euroFormat
        )} €`;
      } else {
        return `${numeral(insuranceValue).format(euroFormat)} €`;
      }
    }
  };
  return (
    <SelectInsuranceSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={SelectInsuranceFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          onSubmitForm(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => {
          const variantHasError = errors && errors.variant && touched.variant;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_select_insurance_select_label"
                      defaultMessage={dlt['onboarding_select_insurance_select_label']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>
              </div>
              <div className="row">
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_country_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_country_placeholder']}
                  >
                    {(placeholder) => (
                      <Select
                        name="variant"
                        value={insuranceSelectData.find((item) => item.value === values.variant)}
                        components={{ DropdownIndicator }}
                        placeholder={"Poistenie 'A'"}
                        classNamePrefix={variantHasError ? 'react-select-error' : 'react-select'}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setInsuranceVariant(e.value);
                          handleChange({
                            target: {
                              name: 'variant',
                              value: e.value,
                            },
                          });
                        }}
                        isOptionDisabled={(op) => op.active === false}
                        options={insuranceSelectData}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                      />
                    )}
                  </FormattedMessage>
                  {variantHasError ? (
                    <SelectInsuranceErrorSC>
                      <FormattedMessage
                        id="onboarding_select_insurance_select_error"
                        defaultMessage={dlt['onboarding_select_insurance_select_error']}
                      />
                    </SelectInsuranceErrorSC>
                  ) : null}
                </div>
              </div>
              {values.variant && (
                <div className="row">
                  <div className="insurance-description">
                    <HeadingFour>
                      {values.variant &&
                        onBoardingStepData.insurance_variants.find(
                          (item) => item.id === values.variant
                        ).name}
                    </HeadingFour>
                    <SmallText className="black-transparent-lighter smaller bolder">
                      {values.variant &&
                        onBoardingStepData.insurance_variants.find(
                          (item) => item.id === values.variant
                        ).description}
                    </SmallText>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="full-block">
                  {values.variant &&
                    onBoardingStepData?.insurance_variants
                      ?.find((item) => item.id === values.variant)
                      ?.questions.map((item, index) => (
                        <div className="check-field" key={item.id}>
                          {item.type === 'boolean' ? (
                            <Checkbox
                              withInsideContent
                              key={item.id}
                              hasError={errors.questions && errors.questions[index]?.answer}
                              name={`questions.${index}.answer`}
                              value={`${
                                values.questions.find((obj, ind) => ind === index)?.answer
                              }`}
                              checked={
                                values.questions.find((obj, ind) => ind === index)?.answer ||
                                index === 0
                              }
                              onChange={(e) => {
                                if (index === 0) {
                                  return;
                                }
                                const value = e.target.checked ? true : false;
                                setFieldValue(`questions.${index}.answer`, value);
                                setFieldValue(`questions.${index}.id`, item.id);
                              }}
                            >
                              {item.question}
                            </Checkbox>
                          ) : (
                            <div className="text-field">
                              <SmallText className="uppercase bold">{item.question}</SmallText>
                              <textarea
                                name={`questions.${index}.answer`}
                                value={`${
                                  values.questions.find((obj, ind) => ind === index)?.answer
                                }`}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setFieldValue(`questions.${index}.answer`, value);
                                  setFieldValue(`questions.${index}.id`, item.id);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ))}

                  {errors.questions && errors.questions.length > 0 ? (
                    <SelectInsuranceErrorSC>
                      <FormattedMessage
                        id="onboarding_select_insurance_required_insurance_fields"
                        defaultMessage={
                          dlt['onboarding_select_insurance_required_insurance_fields']
                        }
                      />
                    </SelectInsuranceErrorSC>
                  ) : null}
                </div>
              </div>

              <div className="additional-data-wrap">
                <div className="additional-data-wrap--item">
                  <SmallText className="black-transparent-lighter smaller bolder">
                    <FormattedMessage
                      id="onboarding_select_insurance_loan_amount"
                      defaultMessage={dlt['onboarding_select_insurance_loan_amount']}
                    />
                  </SmallText>
                  <HeadingFour>
                    {`${numeral(onBoardingStepData.loan_amount).format(euroFormat)} €`}
                  </HeadingFour>
                </div>
                <div className="additional-data-wrap--item">
                  <SmallText className="black-transparent-lighter smaller bolder">
                    <FormattedMessage
                      id="onboarding_select_insurance_number_of_payments"
                      defaultMessage={dlt['onboarding_select_insurance_number_of_payments']}
                    />
                  </SmallText>
                  <HeadingFour>
                    {onBoardingStepData.number_of_payments}{' '}
                    <FormattedMessage
                      id="onboarding_applications_signature_months"
                      defaultMessage={dlt['onboarding_applications_signature_months']}
                    />
                  </HeadingFour>
                </div>
                <div className="additional-data-wrap--item">
                  <SmallText className="black-transparent-lighter smaller bolder">
                    <FormattedMessage
                      id="onboarding_select_insurance_insurance_amount"
                      defaultMessage={dlt['onboarding_select_insurance_insurance_amount']}
                    />
                  </SmallText>
                  <HeadingFour>
                    {values.variant !== null ? calculateInsuranceCost(values.variant) : '-'}
                  </HeadingFour>
                </div>
              </div>

              <div className="row">
                <div className="full-block">
                  <Button
                    type="PRIMARY"
                    className="form-submit"
                    onClick={handleSubmit}
                    withIcon
                    disabled={disabled}
                  >
                    {values.variant !== null ? (
                      <FormattedMessage
                        id="global_continue"
                        defaultMessage={dlt['global_continue']}
                      />
                    ) : (
                      <FormattedMessage
                        id="onboarding_select_insurance_action_without"
                        defaultMessage={dlt['onboarding_select_insurance_action_without']}
                      />
                    )}
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </SelectInsuranceSC>
  );
};

SelectInsurance.defaultProps = {
  euroFormat: '0,00.00',
};

export default injectIntl(SelectInsurance);
